// extracted by mini-css-extract-plugin
export default {"fakeButton":"DocumentDownloadUrl_fakeButton__xYfAq"};